import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { ReactComponent as ProfileMobile } from "../../assets/ProfileMobile.svg";
import AuthButton from './AuthButton';
import { ReactComponent as ArrowRight } from "../../assets/Icon/chevron.leftBackButton.svg";
import { useAppContext } from '../../AppContext';
interface props{
    runAnimation: boolean;
    handleTabClick: (tab: string, path: string) => void;
    handleLoginClick: () => void;
    handleRegisterClick: () => void;
    user: any;
    role: string;
    setRunAnimation: (run: boolean) => void;
    setIsMenuOpen: (isOpen: boolean) => void;
}

function HeaderMobile({ runAnimation, handleTabClick, handleLoginClick, handleRegisterClick, user, role, setRunAnimation, setIsMenuOpen }: props) {
    const {t, i18n}=useTranslation()
    const menuRef = useRef<HTMLDivElement>(null);
    const [languageOpen, setLanguageOpen] = useState(false);
    const {language, setLanguage} = useAppContext();

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setRunAnimation(false);
                setIsMenuOpen(false);
            }
        };

        if (runAnimation) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [runAnimation, setRunAnimation, setIsMenuOpen]);

    return (
        <div
            className={`fixed inset-0 z-40 lg:hidden overflow-scroll ${
                runAnimation ? 'opacity-100' : 'opacity-0 pointer-events-none'
            } transition-opacity duration-300`}
        >
            <div 
                ref={menuRef}
                className={`absolute top-[110px] right-0 w-full h-[calc(100vh-110px)] bg-white transform transition-transform duration-300 ${
                    runAnimation ? 'translate-x-0' : 'translate-x-full'
                }`}
            >
                <div className="flex flex-col h-full">
                    <div className='overflow-y-auto'>
                        <div className='flex flex-col'>
                        {role!="publisher" &&    <button
                                className="h-16 border-b border-gray px-10 flex items-center w-full"
                                onClick={() => handleTabClick("home", "/home")}
                            >
                                <p className="text-black">{t("navigation.home")}</p>
                            </button>}
                            {role !== "publisher" && user && (
                                <button
                                    className="h-16 border-b border-gray px-10 flex items-center w-full"
                                    onClick={() => handleTabClick("myLibrary", "/profile?page=My Library")}
                                >
                                    <p className="text-black">{t("navigation.myLibrary")}</p>
                                </button>
                            )}
                            <button
                                className="h-16 border-b border-gray px-10 flex items-center w-full"
                                onClick={() => handleTabClick("bookStore", "/book-store")}
                            >
                                <p className="text-black">
                                    {role == "publisher"
                                        ? t("navigation.myBooks")
                                        : t("navigation.bookStore")}
                                </p>
                            </button>
                            {role === "publisher" && (
                                <>
                                    <button
                                        className="h-16 border-b border-gray px-10 flex items-center w-full"
                                        onClick={() => handleTabClick("purchases", "/purchases")}
                                    >
                                        <p className="text-black">{t("navigation.purchases")}</p>
                                    </button>
                                    <button
                                        className="h-16 border-b border-gray px-10 flex items-center w-full"
                                        onClick={() => handleTabClick("reports", "/reports")}
                                    >
                                        <p className="text-black">{t("navigation.reports")}</p>
                                    </button>
                                </>
                            )}
                            <button
                                className="h-16 border-b border-gray px-10 flex items-center w-full"
                                onClick={() => handleTabClick("faqs", "/faqs")}
                            >
                                <p className="text-black">{t("navigation.faqs")}</p>
                            </button>
                            <button
                                className="h-16 border-b border-gray px-10 flex items-center w-full"
                                onClick={() => handleTabClick("contactUs", "/contact-us")}
                            >
                                <p className="text-black">{t("navigation.contactUs")}</p>
                            </button>
                            {/* <button
                                className="h-16 border-b border-gray px-10 flex items-center w-full"
                                onClick={() =>
                                    handleTabClick("privacyPolicies", "/privacy-policies")
                                }
                            >
                                <p className="text-black">{t("navigation.privacyPolicies")}</p>
                            </button> */}
                            {role !== "publisher" && (
                                <button
                                    className="h-16 border-b border-gray px-10 flex items-center w-full"
                                    onClick={() => handleTabClick("support", "/support")}
                                >
                                    <p className="text-black">{t("navigation.helpSupport")}</p>
                                </button>
                            )}
                            {/* <button
                                className="h-16 border-b border-gray px-10 flex items-center w-full"
                                onClick={() =>
                                    handleTabClick("termsAndConditions", "/terms-and-conditions")
                                }
                            >
                                <p className="text-black">{t("navigation.termsConditions")}</p>
                            </button> */}
                            <button 
                                className='h-16 border-b border-gray px-10 flex items-center w-full'
                                onClick={() => setLanguageOpen(!languageOpen)}
                            >
                                <div className='flex items-center justify-between w-full'>
                                    <p>
                                        {t("navigation.language")}:<span className='px-[8px] text-[#00726B]'>{language}</span>
                                    </p>
                                    <ArrowRight className={`transform transition-transform duration-300 ${languageOpen ? (i18n.language === 'ar' ? '-rotate-90' : 'rotate-90') : (i18n.language === 'ar' ? 'rotate-180' : 'rotate-0')}`}/>
                                </div>
                            </button>
                            <div className={`overflow-hidden transition-all duration-300 ${languageOpen ? 'max-h-[192px]' : 'max-h-0'}`}>
                                <div className='flex flex-col'>
                                    <button 
                                        className='h-16 border-b border-gray px-10 flex items-center w-full'
                                        onClick={() => {
                                            setLanguage('EN');
                                            setLanguageOpen(false);
                                        }}
                                    >
                                        <p className='text-black px-[8px] text-[14px]'>English</p>
                                    </button>
                                    <button 
                                        className='h-16 border-b border-gray px-10 flex items-center w-full'
                                        onClick={() => {
                                            setLanguage('AR');
                                            setLanguageOpen(false);
                                        }}
                                    >
                                        <p className='text-black px-[8px] text-[14px]'>Arabic</p>
                                    </button>
                                    <button 
                                        className='h-16 border-b border-gray px-10 flex items-center w-full'
                                        onClick={() => {
                                            setLanguage('FR');
                                            setLanguageOpen(false);
                                        }}
                                    >   
                                        <p className='text-black px-[8px] text-[14px]'>French</p>    
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {user && (
                        <div onClick={() => handleTabClick("profile", "/profile")} className="cursor-pointer flex flex-col pt-[32px] pb-[24px] border-t border-[rgba(120,120,120,0.2)]">
                            <div className='flex justify-between gap-[16px]'>
                                <div className="flex items-center gap-[8px] px-[20px]">
                                    <ProfileMobile />
                                    <div>
                                        <p className="text-[#828282]">
                                            {user?.fullname}
                                        </p>
                                        <p className="text-black leading-null">{user?.email}</p>
                                    </div>
                                </div>
                                <div className='flex items-center gap-[8px] px-[20px]'>
                                    <ArrowRight className={`transform transition-transform duration-300 ${i18n.language === 'ar' ? 'rotate-180' : 'rotate-0'}`}/>
                                </div>
                            </div>
                        </div>
                    )}
                    {!user && (
                        <div className="py-[32px] pb-[calc(32px+env(safe-area-inset-bottom,20px))] border-t border-gray">
                            <div className="flex w-full items-center justify-between gap-5 px-10">
                                <div className="w-1/2">
                                    <AuthButton
                                        title={t("navigation.login")}
                                        onClick={handleLoginClick}
                                    />
                                </div>
                                <div className="w-1/2">
                                    <AuthButton
                                        title={t("navigation.register")}
                                        onClick={handleRegisterClick}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default HeaderMobile